export default __webpack_public_path__ + "static/media/13-cn.e66f82d0.webp";